import { useEffect, useRef } from "react";
import { dispatchCusEvent } from "../utils/utils";
import { useLocation } from "react-router-dom";

export default function useCheckPathname() {
  const location = useLocation();
  const tmRef = useRef();

  const comparisonPath = async () => {
    if (window != top) {
      dispatchCusEvent("message", "close-frame", top);
      console.error("принудительное закрытие игры из за редиректа на этот сайт во фрейме");
    }
  };

  useEffect(() => {
    clearTimeout(tmRef.current);
    tmRef.current = setTimeout(() => {
      comparisonPath(window.location.pathname, location.pathname);
    }, 300);
  });
}
